/* iter55u — Extracted from BookDetailModal.jsx.
 *
 * Left column of the modal: cover art + a fixed metadata grid
 * (pages / words / ISBN / edition / publisher).
 */
import React from 'react';
import { resolveCoverUrl } from '@/lib/bookstoreApi';
import { formatIsbn } from '@/lib/format';

export default function BookDetailCover({ book }) {
  const wip = !!book?.is_wip;
  const front = resolveCoverUrl(book?.cover_front_url || book?.cover_url);
  return (
    <div className="relative">
      {front ? (
        <img
          src={front}
          alt={book.title || 'Cover'}
          className="w-full rounded-md object-cover"
          data-testid={`book-detail-cover-${book.id}`}
        />
      ) : (
        <div
          className="flex aspect-[2/3] items-center justify-center rounded-md border border-dashed border-border bg-muted/40 text-[13px] text-muted-foreground"
          data-testid={`book-detail-cover-placeholder-${book.id}`}
        >
          {book?.title || 'Untitled'}
        </div>
      )}
      {/* iter-p3-aa — WIP sample ribbon so readers can tell a preview
       *  from a finished book at a glance. Pure CSS overlay to avoid
       *  server-side image compositing. */}
      {wip && (
        <div
          className="pointer-events-none absolute inset-0"
          data-testid={`book-detail-wip-ribbon-${book.id}`}
        >
          <div className="absolute right-0 top-6 origin-top-right -translate-y-1/2 rotate-45 translate-x-8 bg-oxblood px-10 py-1 text-center text-[10px] font-bold uppercase tracking-[0.25em] text-white shadow-md">
            Sample
          </div>
        </div>
      )}
      {/* iter-460ec1b-restore — Fixed metadata grid dropped in a prior
          dead-code cleanup. Guarded with `|| 0` since older seed/test
          rows don't always carry page_count/word_count. */}
      <div className="mt-3 grid grid-cols-2 gap-1 text-[11px] text-muted-foreground">
        <div>Pages</div><div className="text-right text-foreground">{(book.page_count || 0).toLocaleString()}</div>
        <div>Words</div><div className="text-right text-foreground">{(book.word_count || 0).toLocaleString()}</div>
        {book.isbn && (
          <>
            <div>ISBN</div>
            <div data-testid={`book-isbn-${book.id}`} className="text-right font-mono text-foreground">
              {formatIsbn(book.isbn)}
            </div>
          </>
        )}
        {book.edition && (
          <>
            <div>Edition</div>
            <div className="text-right text-foreground">{book.edition}</div>
          </>
        )}
        {book.publisher_of_record && (
          <>
            <div>Publisher</div>
            <div data-testid={`book-publisher-${book.id}`} className="text-right text-foreground">
              {book.publisher_of_record}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
